// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Color Variables */
:root {
  --compact-primary: #2563eb;
  --compact-primary-light: #dbeafe;
  --compact-secondary: #f8fafc;
  --compact-text: #1e293b;
  --compact-text-light: #64748b;
  --compact-border: #e2e8f0;
  --compact-accent-blue: #3b82f6;
  --compact-accent-purple: #8b5cf6;
  --compact-white: #ffffff;
  --compact-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),
    0 8px 10px -6px rgba(0, 0, 0, 0.05);
  --compact-card-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  --compact-success: #22c55e;
  --compact-warning: #f97316;
  --compact-warning-dark: #ea580c;
  --compact-danger: #ef4444;
}

.compact-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 0;
}

.compact-modal-container {
  background: var(--compact-white);
  border-radius: 8px;
  box-shadow: var(--compact-shadow);
  width: 100vw;
  max-width: 97vw;
  height: 100vh;
  max-height: 97vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  transform: translateY(0);
  animation: compact-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes compact-modal-appear {
  to {
    transform: translateY(0);
  }
}
/* Filter Dropdown Styles */
.company-modal-filter-dropdown {
  position: absolute;
  top: 100%;
  background: var(--compact-white);
  border: 1px solid var(--compact-border);
  border-radius: 8px;
  box-shadow: var(--compact-shadow);
  z-index: 1001;
  width: 400px;
  padding: 16px;
  margin-top: 8px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
}
.company-modal-filter-dropdown .filter-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: var(--compact-text);
  margin-bottom: 6px;
}
.company-modal-filter-dropdown .filter-group select,
.company-modal-filter-dropdown .filter-group input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  font-size: 14px;
  color: var(--compact-text);
  background: var(--compact-white);
  transition: border-color 0.2s ease;
}
.company-modal-filter-dropdown .filter-group select:focus,
.company-modal-filter-dropdown .filter-group input:focus {
  outline: none;
  border-color: var(--compact-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.company-modal-filter-dropdown .filter-group .filter-date-row {
  display: flex;
  gap: 8px;
}
.company-modal-filter-dropdown .filter-group .filter-date-row input {
  flex: 1 1;
}
.company-modal-filter-dropdown .filter-actions {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--compact-border);
  transform: translateY(15px);
  position: sticky;
  bottom: 4px;
  background: white;
  z-index: 100;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn,
.company-modal-filter-dropdown .filter-actions .filter-close-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn {
  background: var(--compact-danger);
  color: white;
}
.company-modal-filter-dropdown .filter-actions .filter-clear-btn:hover {
  background: #dc2626;
}
.company-modal-filter-dropdown .filter-actions .filter-close-btn {
  background: var(--compact-secondary);
  color: var(--compact-text);
}
.company-modal-filter-dropdown .filter-actions .filter-close-btn:hover {
  background: #f1f5f9;
}

.compact-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid var(--compact-border);
}

.compact-modal-content {
  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);
  max-height: 300px;
  opacity: 1;
  overflow: hidden;
  transform-origin: top;
  transform: translateY(0);
}
.compact-modal-content.collapsed {
  max-height: 0;
  opacity: 0;
  margin-bottom: 0;
  transform: translateY(-10px);
  transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);
}

.compact-modal-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: var(--compact-text);
  margin: 0;
}
.compact-modal-header h3 .company-name {
  color: var(--compact-primary);
  font-weight: 500;
  font-size: 16px;
}

.compact-close-button {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: var(--compact-text-light);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.compact-close-button:hover {
  color: var(--compact-text);
  background: var(--compact-secondary);
}

/* Image-style stats container */
.image-style-stats-container {
  display: flex;
  gap: 20px;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  overflow-x: auto;
  align-items: stretch;
}

/* Individual stat cards */
.image-style-stat-card {
  flex: 1 1;
  min-width: 180px;
  background: white;
  border-radius: 12px;
  padding: 12px;
  gap: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
}

/* Icon styling */
.image-style-stat-card .head-img {
  display: flex;
  align-items: center;
  gap: 10px;
}
.image-style-stat-card .head-img .stat-icon {
  width: 30px;
  height: 30px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
}

/* Content area */
.image-style-stat-card .stat-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Typography */
.image-style-stat-card .stat-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.image-style-stat-card .stat-value {
  font-size: 20px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.image-style-stat-card .number-value-stat-comp {
  margin-top: 0.8rem;
}

.image-style-stat-card .stat-sublabel {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.image-style-stat-card .stat-percentage {
  font-size: 12px;
  color: #64748b;
  font-weight: 600;
  margin-top: 2px;
}

/* Progress bars */
.image-style-stat-card .stat-progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 3px;
  overflow: hidden;
  margin: 8px 0 4px 0;
}

.image-style-stat-card .stat-progress-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.6s ease-out;
}

/* Specific card colors */
.users-card .stat-icon {
  background: #7c3aed;
}

.users-card .stat-progress-fill.users-progress {
  background: #7c3aed;
}

.cases-card .stat-icon {
  background: #2563eb;
}

.cases-card .stat-progress-fill.cases-progress {
  background: #2563eb;
}

.highcourt-card .stat-icon {
  background: #059669;
}

.highcourt-card .stat-progress-fill.highcourt-progress {
  background: #059669;
}

.districtcourt-card .stat-icon {
  background: #dc2626;
}

.districtcourt-card .stat-progress-fill.districtcourt-progress {
  background: #dc2626;
}

.othercourts-card .stat-icon {
  background: #7c2d12;
}

.othercourts-card .stat-progress-fill.othercourts-progress {
  background: #7c2d12;
}

.supremecourt-card .stat-icon {
  background: #6d28d9;
}

/* Footer with integrated pagination */
.compact-modal-footer {
  padding: 16px 24px;
  border-top: 1px solid var(--compact-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.compact-modal-footer .footer-buttons {
  display: flex;
  gap: 12px;
  align-items: center;
}

.compact-modal-footer button {
  padding: 8px 18px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
  border: none;
}

.compact-modal-footer button:last-child {
  background: var(--compact-border);
  color: var(--compact-text);
}

.compact-modal-footer button:last-child:hover {
  background: #cbd5e1;
}

.update-cases-btn {
  background: var(--primary-color);
  color: var(--compact-white);
}

.update-cases-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.update-cases-btn:disabled {
  background: var(--compact-text-light);
  cursor: not-allowed;
  opacity: 0.6;
}

/* Pagination in Footer Styles */
.manage-cases-pagination-compact {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 13px;
}

.pagination-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pagination-select {
  padding: 6px 10px;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  font-size: 13px;
  color: var(--compact-text);
  background: var(--compact-white);
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.pagination-select:focus {
  outline: none;
  border-color: var(--compact-primary);
}

.pagination-nav {
  display: flex;
  align-items: center;
  gap: 6px;
}

.pagination-btn-compact {
  width: 28px;
  height: 28px;
  padding: 0;
  border: 1px solid var(--compact-border);
  border-radius: 6px;
  background: var(--compact-white);
  color: var(--compact-text);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn-compact:hover:not(:disabled) {
  background: var(--compact-primary-light);
  border-color: var(--compact-primary);
  color: var(--compact-primary);
}

.pagination-btn-compact:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pagination-info-compact {
  font-size: 13px;
  color: var(--compact-text);
  font-weight: 500;
  min-width: 50px;
  text-align: center;
}

.pagination-total-compact {
  font-size: 12px;
  color: var(--compact-text-light);
  font-weight: 500;
}

/* Loading and Error States */
.compact-modal-loading,
.compact-modal-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  text-align: center;
}

.compact-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--compact-border);
  border-top: 3px solid var(--compact-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

.compact-modal-loading p {
  margin: 0;
  font-size: 14px;
  color: var(--compact-text-light);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.compact-modal-error p {
  color: #dc2626;
  margin-bottom: 16px;
  font-size: 14px;
}

.compact-modal-error button {
  background: var(--compact-primary);
  color: var(--compact-white);
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
}

/* Updated Modern Compact Manage Cases Section */
.manage-cases-section {
  padding: 16px 20px;
  overflow-y: auto;
  border-radius: 12px;
  min-height: 0;
  flex: 1 1;
}

/* Compact Modern Tab System */
.manage-cases-tabs {
  display: flex;
  gap: 2px;
  margin-bottom: 12px;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.manage-cases-tab {
  flex: 1 1;
  padding: 8px 14px;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
  white-space: nowrap;
}

.manage-cases-tab.active {
  background: white;
  color: var(--primary-color);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.manage-cases-tab:hover:not(.active) {
  color: #475569;
  background: rgba(255, 255, 255, 0.5);
}

/* Compact Sub-tabs */
.manage-cases-subtabs {
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  align-items: center;
  justify-content: space-between;
}

.manage-cases-subtab {
  padding: 8px 18px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.manage-cases-subtab.active {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.manage-cases-subtab:hover:not(.active) {
  border-color: #cbd5e1;
  background: #f1f5f9;
}

/* Compact Cases List */
.manage-cases-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0;
}

/* Compact Case Cards */
.manage-case-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 60px;
}

.manage-case-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
  transform: translateY(-1px);
}

.manage-case-card.focused {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  transform: translateY(-1px);
}

/* Disabled/Assigned state */
.manage-case-card.assigned {
  background: #f8f9fa;
  opacity: 0.65;
  cursor: not-allowed !important;
}
.manage-case-card.assigned:hover {
  border-color: #e2e8f0;
  box-shadow: none;
  transform: none;
}
.manage-case-card.assigned .case-checkbox {
  cursor: not-allowed;
  opacity: 0.5;
}

.manage-case-checkbox {
  position: static;
  flex-shrink: 0;
  margin: 0;
}

.case-checkbox {
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: var(--primary-color);
}

.manage-case-details {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0;
  min-height: auto;
}

.manage-case-main-info {
  flex: 1 1;
  min-width: 0;
}

.manage-case-parties {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.manage-case-secondary-info {
  display: flex;
  gap: 16px;
  margin: 0;
  align-items: center;
}

.manage-case-info-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  padding: 0;
  background: none;
  border: none;
  border-radius: 0;
}

.manage-case-label {
  font-weight: 500;
  color: #64748b;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  min-width: auto;
}

.manage-case-info-item span:last-child {
  color: #475569;
  font-weight: 500;
  font-size: 11px;
}

.manage-case-right-info {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0;
  border: none;
  flex-shrink: 0;
}

.manage-case-status {
  display: flex;
  align-items: center;
}

.manage-case-status-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: 1px solid;
  white-space: nowrap;
}

.manage-case-status-badge.disposed {
  background: #dcfce7;
  color: #166534;
  border-color: #bbf7d0;
}

.manage-case-status-badge.pending {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a;
}

.manage-case-status-badge.na {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.manage-case-date {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 10px;
}

.manage-case-date .manage-case-label {
  margin: 0;
  font-size: 9px;
}

.manage-case-date span:last-child {
  color: #1e293b;
  font-weight: 600;
  font-size: 10px;
  white-space: nowrap;
}

/* Loading, Error, Empty States */
.manage-cases-loading,
.manage-cases-error,
.manage-cases-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  text-align: center;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px dashed #cbd5e1;
}

.manage-cases-spinner {
  width: 24px;
  height: 24px;
  border: 2px solid #e2e8f0;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 12px;
}

.manage-cases-loading p,
.manage-cases-empty p {
  margin: 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.manage-cases-error p {
  color: #dc2626;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 500;
}

.manage-cases-error button {
  background: #dc2626;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.manage-cases-error button:hover {
  background: #b91c1c;
}

.options-courts {
  display: flex;
  gap: 6px;
}

/* Selection Counter Styles */
.selection-counter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  flex-wrap: wrap;
  gap: 8px;
}

/* Keyboard Navigation Hint */
.keyboard-nav-hint {
  padding: 6px 12px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  margin-bottom: 12px;
  text-align: center;
}
.keyboard-nav-hint small {
  color: #1e40af;
  font-size: 11px;
  font-weight: 500;
}
.keyboard-nav-hint kbd {
  display: inline-block;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  color: #1e293b;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  margin: 0 2px;
}

.selection-count {
  font-weight: 600;
  color: #475569;
}

.selection-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-left: auto;
}

.select-all-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

/* Base styles for new action buttons */
.select-all-cases-btn,
.clear-page-btn {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.select-all-cases-btn:disabled,
.clear-page-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Specific styles for the new buttons */
.select-all-cases-btn {
  background: var(--compact-primary);
  color: white;
}
.select-all-cases-btn:hover:not(:disabled) {
  background: #1d4ed8;
}

.clear-page-btn {
  background: var(--compact-warning);
  color: white;
}
.clear-page-btn:hover:not(:disabled) {
  background: var(--compact-warning-dark);
}

.clear-selection-btn {
  padding: 4px 8px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.clear-selection-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

/* Limit Exceeded Modal Styles */
.limit-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 16px;
}

.limit-modal-container {
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  width: 100%;
  max-width: 400px;
  overflow: hidden;
  animation: limit-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes limit-modal-appear {
  from {
    transform: translateY(20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.limit-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  background: #fef2f2;
  border-bottom: 1px solid #fecaca;
}

.limit-modal-header h4 {
  font-size: 16px;
  font-weight: 600;
  color: #dc2626;
  margin: 0;
}

.limit-modal-close {
  background: transparent;
  border: none;
  font-size: 20px;
  color: #dc2626;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
}

.limit-modal-close:hover {
  background: rgba(220, 38, 38, 0.1);
}

.limit-modal-content {
  padding: 20px;
  text-align: center;
}

.limit-modal-content p {
  margin: 0 0 12px 0;
  color: #64748b;
  font-size: 14px;
  line-height: 1.5;
}

.limit-modal-content p:last-child {
  margin-bottom: 0;
}

.limit-modal-content strong {
  color: #dc2626;
  font-weight: 600;
}

.limit-modal-footer {
  padding: 16px 20px;
  background: #f8fafc;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.limit-modal-upgrade-btn {
  padding: 8px 24px;
  background: #ff7e5f;
  background: linear-gradient(to right, #ff7e5f, #feb47b);
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.limit-modal-btn {
  padding: 8px 24px;
  background: #dc2626;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.limit-modal-btn:hover {
  background: #b91c1c;
  transform: translateY(-1px);
}

.sa-search-wrapper {
  display: flex;
  align-items: center;
  position: relative;
}

.sa-search-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.sa-search-input {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  background: white;
}

.sa-search-loading {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary-color);
}

.sa-spinner {
  animation: spin 1s linear infinite;
}

.icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--border-light);
  color: var(--text-medium);
  position: relative;
}
.icon-btn svg {
  width: 16px;
  height: 16px;
}
.icon-btn.active {
  background: var(--primary-light);
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
}
.icon-btn.active-filter {
  background: var(--primary-light-bg);
}
.icon-btn .filter-indicator {
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
  border: 2px solid white;
}

/* Responsive Adjustments */
@media (max-width: 1200px) {
  .compact-modal-container {
    max-width: 900px;
  }
  .image-style-stats-container {
    flex-wrap: wrap;
  }
  .image-style-stat-card {
    min-width: 160px;
  }
}
@media (max-width: 900px) {
  .manage-cases-section {
    padding: 16px;
  }
  .manage-cases-tabs {
    flex-direction: column;
    gap: 4px;
  }
  .manage-cases-tab {
    padding: 8px 12px;
  }
  .manage-case-details {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .manage-case-secondary-info {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  .manage-case-right-info {
    width: 100%;
    justify-content: space-between;
  }
  .image-style-stats-container {
    flex-direction: column;
    gap: 12px;
  }
  .image-style-stat-card {
    min-width: auto;
  }
  .compact-modal-content {
    max-height: 1000px;
  }
}
@media (max-width: 768px) {
  .selection-counter {
    flex-direction: column;
    align-items: flex-start;
  }
  .selection-actions {
    width: 100%;
    justify-content: flex-start;
    margin-left: 0;
  }
}
@media (max-width: 600px) {
  .manage-case-card {
    padding: 10px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .manage-case-checkbox {
    position: absolute;
    top: 12px;
    right: 12px;
  }
  .manage-case-details {
    width: 100%;
    padding-right: 30px;
  }
  .manage-case-parties {
    white-space: normal;
    overflow: visible;
    text-overflow: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .selection-counter {
    flex-direction: column;
    gap: 8px;
    align-items: stretch;
    text-align: center;
  }
  .clear-selection-btn {
    width: 100%;
    padding: 6px 12px;
  }
  .limit-modal-container {
    max-width: 350px;
    margin: 0 16px;
  }
  .compact-modal-footer {
    flex-direction: column;
    gap: 12px;
  }
  .manage-cases-pagination-compact {
    width: 100%;
  }
  .footer-buttons {
    width: 100%;
    justify-content: stretch;
  }
  .footer-buttons button {
    flex: 1 1;
  }
  .image-style-stat-card {
    padding: 16px 12px;
    gap: 10px;
  }
  .image-style-stat-card .stat-icon {
    width: 40px;
    height: 40px;
  }
  .image-style-stat-card .stat-value {
    font-size: 28px;
  }
}
@media (max-width: 500px) {
  .manage-cases-section {
    padding: 16px;
  }
  .manage-cases-tabs {
    flex-direction: column;
  }
  .manage-cases-tab {
    text-align: center;
  }
  .manage-case-card {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CompanyModalLimit/CompanyModalLimit.scss"],"names":[],"mappings":"AAAA,oBAAA;AACA;EACE,0BAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;EACA,gCAAA;EACA,wBAAA;EACA;uCAAA;EAEA,oDAAA;EACA,0BAAA;EACA,0BAAA;EACA,+BAAA;EACA,yBAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AACF;;AAEA;EACE,gCAAA;EACA,kBAAA;EACA,iCAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,wBAAA;EACA,+EAAA;AACF;;AAGA;EACE;IACE,wBAAA;EAAF;AACF;AAGA,2BAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,uCAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AADF;AAKI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;AAHN;AAMI;;EAEE,WAAA;EACA,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,kCAAA;AAJN;AAMM;;EACE,aAAA;EACA,oCAAA;EACA,4CAAA;AAHR;AAOI;EACE,aAAA;EACA,QAAA;AALN;AAOM;EACE,SAAA;AALR;AAUE;EACE,aAAA;EACA,QAAA;EACA,8BAAA;EACA,iBAAA;EACA,2CAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;AARJ;AAUI;;EAEE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AARN;AAWI;EACE,iCAAA;EACA,YAAA;AATN;AAWM;EACE,mBAAA;AATR;AAaI;EACE,oCAAA;EACA,0BAAA;AAXN;AAaM;EACE,mBAAA;AAXR;;AAiBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,8CAAA;AAdF;;AAiBA;EACE,kDAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAAA;AAdF;AAgBE;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,4BAAA;EACA,kDAAA;AAdJ;;AAkBA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAfF;AAiBE;EACE,6BAAA;EACA,gBAAA;EACA,eAAA;AAfJ;;AAmBA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gCAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AAhBF;;AAmBA;EACE,0BAAA;EACA,oCAAA;AAhBF;;AAmBA,gCAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAhBF;;AAmBA,0BAAA;AACA;EACE,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,yCAAA;EACA,qDAAA;EACA,gBAAA;AAhBF;;AAmBA,iBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhBF;AAiBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;AAfJ;;AAmBA,iBAAA;AACA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAhBF;;AAmBA,eAAA;AACA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAhBF;;AAmBA,kBAAA;AACA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,kBAAA;EACA,+BAAA;AAhBF;;AAmBA,yBAAA;AACA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA,sCAAA;AACA;EACE,kBAAA;EACA,2CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,sCAAA;EACA,YAAA;AAhBF;;AAmBA;EACE,iCAAA;EACA,0BAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,gCAAA;EACA,2BAAA;AAhBF;;AAmBA;EACE,mBAAA;AAhBF;;AAmBA;EACE,qCAAA;EACA,mBAAA;EACA,YAAA;AAhBF;;AAmBA,gCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAhBF;;AAmBA;EACE,iBAAA;EACA,uCAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,gCAAA;EACA,eAAA;EACA,kCAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,oCAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;EACA,gCAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;;AAmBA;EACE,wCAAA;EACA,oCAAA;EACA,6BAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,eAAA;EACA,gCAAA;EACA,gBAAA;AAhBF;;AAmBA,6BAAA;AACA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,WAAA;EACA,YAAA;EACA,uCAAA;EACA,4CAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,SAAA;EACA,eAAA;EACA,gCAAA;AAhBF;;AAmBA;EACE;IACE,uBAAA;EAhBF;EAkBA;IACE,yBAAA;EAhBF;AACF;AAmBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;AAjBF;;AAoBA;EACE,kCAAA;EACA,2BAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAjBF;;AAoBA,gDAAA;AACA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAjBF;;AAoBA,8BAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAjBF;;AAoBA;EACE,SAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,2BAAA;EACA,wCAAA;AAjBF;;AAoBA;EACE,cAAA;EACA,oCAAA;AAjBF;;AAoBA,qBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,gCAAA;EACA,YAAA;EACA,kCAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,mBAAA;AAjBF;;AAoBA,uBAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,UAAA;AAjBF;;AAoBA,uBAAA;AACA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,6CAAA;EACA,2BAAA;AAjBF;;AAoBA;EACE,qBAAA;EACA,mBAAA;EACA,8CAAA;EACA,2BAAA;AAjBF;;AAoBA,4BAAA;AACA;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AAjBF;AAmBE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;AAjBJ;AAoBE;EACE,mBAAA;EACA,YAAA;AAlBJ;;AAsBA;EACE,gBAAA;EACA,cAAA;EACA,SAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,YAAA;AAnBF;;AAsBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EACA,eAAA;AAnBF;;AAsBA;EACE,SAAA;EACA,cAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAnBF;;AAsBA,iCAAA;AACA;;;EAGE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;AAnBF;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;AAnBF;;AAsBA;;EAEE,SAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,mBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,mBAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,QAAA;AAnBF;;AAsBA,6BAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,QAAA;AAnBF;;AAsBA,6BAAA;AACA;EACE,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;AAsBE;EACE,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,aAAA;AApBJ;;AAwBA;EACE,gBAAA;EACA,cAAA;AArBF;;AAwBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AArBF;;AAwBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AArBF;;AAwBA,uCAAA;AACA;;EAEE,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AArBF;AAuBE;;EACE,YAAA;EACA,mBAAA;AApBJ;;AAwBA,wCAAA;AACA;EACE,kCAAA;EACA,YAAA;AArBF;AAuBE;EACE,mBAAA;AArBJ;;AAyBA;EACE,kCAAA;EACA,YAAA;AAtBF;AAwBE;EACE,uCAAA;AAtBJ;;AA0BA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAvBF;;AA0BA;EACE,mBAAA;EACA,2BAAA;AAvBF;;AA0BA,gCAAA;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AAvBF;;AA0BA;EACE,iBAAA;EACA,mBAAA;EACA,qFAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6EAAA;AAvBF;;AA0BA;EACE;IACE,uCAAA;IACA,UAAA;EAvBF;EAyBA;IACE,iCAAA;IACA,UAAA;EAvBF;AACF;AA0BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAxBF;;AA2BA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AAxBF;;AA2BA;EACE,kCAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,kBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,gBAAA;AAxBF;;AA2BA;EACE,cAAA;EACA,gBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAxBF;;AA2BA;EACE,iBAAA;EACA,mBAAA;EACA,uDAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;AAxBF;;AA2BA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAxBF;;AA2BA;EACE,mBAAA;EACA,2BAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,iBAAA;AAxBF;;AA2BA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,2BAAA;AAxBF;;AA2BA;EACE,kCAAA;AAxBF;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,iDAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AAxBF;AA0BE;EACE,WAAA;EACA,YAAA;AAxBJ;AA2BE;EACE,gCAAA;EACA,2BAAA;EACA,sCAAA;AAzBJ;AA4BE;EACE,mCAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,sCAAA;EACA,kBAAA;EACA,uBAAA;AA3BJ;;AA+BA,2BAAA;AACA;EACE;IACE,gBAAA;EA5BF;EA+BA;IACE,eAAA;EA7BF;EAgCA;IACE,gBAAA;EA9BF;AACF;AAiCA;EACE;IACE,aAAA;EA/BF;EAkCA;IACE,sBAAA;IACA,QAAA;EAhCF;EAmCA;IACE,iBAAA;EAjCF;EAoCA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAlCF;EAqCA;IACE,sBAAA;IACA,uBAAA;IACA,QAAA;EAnCF;EAsCA;IACE,WAAA;IACA,8BAAA;EApCF;EAuCA;IACE,sBAAA;IACA,SAAA;EArCF;EAwCA;IACE,eAAA;EAtCF;EAyCA;IACE,kBAAA;EAvCF;AACF;AA0CA;EACE;IACE,sBAAA;IACA,uBAAA;EAxCF;EA0CA;IACE,WAAA;IACA,2BAAA;IACA,cAAA;EAxCF;AACF;AA2CA;EACE;IACE,kBAAA;IACA,sBAAA;IACA,uBAAA;IACA,QAAA;EAzCF;EA4CA;IACE,kBAAA;IACA,SAAA;IACA,WAAA;EA1CF;EA6CA;IACE,WAAA;IACA,mBAAA;EA3CF;EA8CA;IACE,mBAAA;IACA,iBAAA;IACA,sBAAA;IACA,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;EA5CF;EA+CA;IACE,sBAAA;IACA,QAAA;IACA,oBAAA;IACA,kBAAA;EA7CF;EAgDA;IACE,WAAA;IACA,iBAAA;EA9CF;EAiDA;IACE,gBAAA;IACA,cAAA;EA/CF;EAkDA;IACE,sBAAA;IACA,SAAA;EAhDF;EAmDA;IACE,WAAA;EAjDF;EAoDA;IACE,WAAA;IACA,wBAAA;EAlDF;EAqDA;IACE,SAAA;EAnDF;EAsDA;IACE,kBAAA;IACA,SAAA;EApDF;EAuDA;IACE,WAAA;IACA,YAAA;EArDF;EAwDA;IACE,eAAA;EAtDF;AACF;AAyDA;EACE;IACE,aAAA;EAvDF;EA0DA;IACE,sBAAA;EAxDF;EA2DA;IACE,kBAAA;EAzDF;EA4DA;IACE,aAAA;EA1DF;AACF","sourcesContent":["/* Color Variables */\r\n:root {\r\n  --compact-primary: #2563eb;\r\n  --compact-primary-light: #dbeafe;\r\n  --compact-secondary: #f8fafc;\r\n  --compact-text: #1e293b;\r\n  --compact-text-light: #64748b;\r\n  --compact-border: #e2e8f0;\r\n  --compact-accent-blue: #3b82f6;\r\n  --compact-accent-purple: #8b5cf6;\r\n  --compact-white: #ffffff;\r\n  --compact-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1),\r\n    0 8px 10px -6px rgba(0, 0, 0, 0.05);\r\n  --compact-card-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\r\n  --compact-success: #22c55e;\r\n  --compact-warning: #f97316;\r\n  --compact-warning-dark: #ea580c;\r\n  --compact-danger: #ef4444;\r\n}\r\n\r\n.compact-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(15, 23, 42, 0.6);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 0;\r\n}\r\n\r\n.compact-modal-container {\r\n  background: var(--compact-white);\r\n  border-radius: 8px;\r\n  box-shadow: var(--compact-shadow);\r\n  width: 100vw;\r\n  max-width: 97vw;\r\n  height: 100vh;\r\n  max-height: 97vh;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  transition: all 0.3s ease;\r\n  transform: translateY(0);\r\n  animation: compact-modal-appear 0.3s forwards\r\n    cubic-bezier(0.34, 1.56, 0.64, 1);\r\n}\r\n\r\n@keyframes compact-modal-appear {\r\n  to {\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Filter Dropdown Styles */\r\n.company-modal-filter-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  background: var(--compact-white);\r\n  border: 1px solid var(--compact-border);\r\n  border-radius: 8px;\r\n  box-shadow: var(--compact-shadow);\r\n  z-index: 1001;\r\n  width: 400px;\r\n  padding: 16px;\r\n  margin-top: 8px;\r\n  max-height: 250px;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  \r\n\r\n  .filter-group {\r\n    label {\r\n      display: block;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      color: var(--compact-text);\r\n      margin-bottom: 6px;\r\n    }\r\n\r\n    select,\r\n    input {\r\n      width: 100%;\r\n      padding: 8px 12px;\r\n      border: 1px solid var(--compact-border);\r\n      border-radius: 6px;\r\n      font-size: 14px;\r\n      color: var(--compact-text);\r\n      background: var(--compact-white);\r\n      transition: border-color 0.2s ease;\r\n\r\n      &:focus {\r\n        outline: none;\r\n        border-color: var(--compact-primary);\r\n        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\r\n      }\r\n    }\r\n\r\n    .filter-date-row {\r\n      display: flex;\r\n      gap: 8px;\r\n\r\n      input {\r\n        flex: 1;\r\n      }\r\n    }\r\n  }\r\n\r\n  .filter-actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    justify-content: space-between;\r\n    padding-top: 16px;\r\n    border-top: 1px solid var(--compact-border);\r\n    transform: translateY(15px);\r\n    position: sticky;\r\n    bottom: 4px;\r\n    background: white;\r\n    z-index: 100;\r\n\r\n    .filter-clear-btn,\r\n    .filter-close-btn {\r\n      padding: 8px 16px;\r\n      border: none;\r\n      border-radius: 6px;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      cursor: pointer;\r\n      transition: all 0.2s ease;\r\n    }\r\n\r\n    .filter-clear-btn {\r\n      background: var(--compact-danger);\r\n      color: white;\r\n\r\n      &:hover {\r\n        background: #dc2626;\r\n      }\r\n    }\r\n\r\n    .filter-close-btn {\r\n      background: var(--compact-secondary);\r\n      color: var(--compact-text);\r\n\r\n      &:hover {\r\n        background: #f1f5f9;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.compact-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 20px 24px;\r\n  border-bottom: 1px solid var(--compact-border);\r\n}\r\n\r\n.compact-modal-content {\r\n  transition: all 0.6s cubic-bezier(0.25, 1, 0.5, 1);\r\n  max-height: 300px;\r\n  opacity: 1;\r\n  overflow: hidden;\r\n  transform-origin: top;\r\n  transform: translateY(0);\r\n\r\n  &.collapsed {\r\n    max-height: 0;\r\n    opacity: 0;\r\n    margin-bottom: 0;\r\n    transform: translateY(-10px);\r\n    transition: all 0.4s cubic-bezier(0.25, 1, 0.5, 1);\r\n  }\r\n}\r\n\r\n.compact-modal-header h3 {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: var(--compact-text);\r\n  margin: 0;\r\n\r\n  .company-name {\r\n    color: var(--compact-primary);\r\n    font-weight: 500;\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n.compact-close-button {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 24px;\r\n  line-height: 1;\r\n  color: var(--compact-text-light);\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.compact-close-button:hover {\r\n  color: var(--compact-text);\r\n  background: var(--compact-secondary);\r\n}\r\n\r\n/* Image-style stats container */\r\n.image-style-stats-container {\r\n  display: flex;\r\n  gap: 20px;\r\n  padding: 20px;\r\n  background: #f8fafc;\r\n  border-radius: 12px;\r\n  overflow-x: auto;\r\n  align-items: stretch;\r\n}\r\n\r\n/* Individual stat cards */\r\n.image-style-stat-card {\r\n  flex: 1;\r\n  min-width: 180px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 12px;\r\n  gap: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Icon styling */\r\n.image-style-stat-card .head-img {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  .stat-icon {\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n    color: white;\r\n  }\r\n}\r\n\r\n/* Content area */\r\n.image-style-stat-card .stat-content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n\r\n/* Typography */\r\n.image-style-stat-card .stat-label {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.image-style-stat-card .stat-value {\r\n  font-size: 20px;\r\n  font-weight: 700;\r\n  color: #1e293b;\r\n  line-height: 1;\r\n}\r\n\r\n.image-style-stat-card .number-value-stat-comp {\r\n  margin-top: 0.8rem;\r\n}\r\n\r\n.image-style-stat-card .stat-sublabel {\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n.image-style-stat-card .stat-percentage {\r\n  font-size: 12px;\r\n  color: #64748b;\r\n  font-weight: 600;\r\n  margin-top: 2px;\r\n}\r\n\r\n/* Progress bars */\r\n.image-style-stat-card .stat-progress-bar {\r\n  height: 6px;\r\n  background: #e2e8f0;\r\n  border-radius: 3px;\r\n  overflow: hidden;\r\n  margin: 8px 0 4px 0;\r\n}\r\n\r\n.image-style-stat-card .stat-progress-fill {\r\n  height: 100%;\r\n  border-radius: 3px;\r\n  transition: width 0.6s ease-out;\r\n}\r\n\r\n/* Specific card colors */\r\n.users-card .stat-icon {\r\n  background: #7c3aed;\r\n}\r\n\r\n.users-card .stat-progress-fill.users-progress {\r\n  background: #7c3aed;\r\n}\r\n\r\n.cases-card .stat-icon {\r\n  background: #2563eb;\r\n}\r\n\r\n.cases-card .stat-progress-fill.cases-progress {\r\n  background: #2563eb;\r\n}\r\n\r\n.highcourt-card .stat-icon {\r\n  background: #059669;\r\n}\r\n\r\n.highcourt-card .stat-progress-fill.highcourt-progress {\r\n  background: #059669;\r\n}\r\n\r\n.districtcourt-card .stat-icon {\r\n  background: #dc2626;\r\n}\r\n\r\n.districtcourt-card .stat-progress-fill.districtcourt-progress {\r\n  background: #dc2626;\r\n}\r\n\r\n.othercourts-card .stat-icon {\r\n  background: #7c2d12;\r\n}\r\n\r\n.othercourts-card .stat-progress-fill.othercourts-progress {\r\n  background: #7c2d12;\r\n}\r\n\r\n.supremecourt-card .stat-icon {\r\n  background: #6d28d9;\r\n}\r\n\r\n/* Footer with integrated pagination */\r\n.compact-modal-footer {\r\n  padding: 16px 24px;\r\n  border-top: 1px solid var(--compact-border);\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.compact-modal-footer .footer-buttons {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.compact-modal-footer button {\r\n  padding: 8px 18px;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  border: none;\r\n}\r\n\r\n.compact-modal-footer button:last-child {\r\n  background: var(--compact-border);\r\n  color: var(--compact-text);\r\n}\r\n\r\n.compact-modal-footer button:last-child:hover {\r\n  background: #cbd5e1;\r\n}\r\n\r\n.update-cases-btn {\r\n  background: var(--primary-color);\r\n  color: var(--compact-white);\r\n}\r\n\r\n.update-cases-btn:hover:not(:disabled) {\r\n  background: #1d4ed8;\r\n}\r\n\r\n.update-cases-btn:disabled {\r\n  background: var(--compact-text-light);\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* Pagination in Footer Styles */\r\n.manage-cases-pagination-compact {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  font-size: 13px;\r\n}\r\n\r\n.pagination-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n}\r\n\r\n.pagination-select {\r\n  padding: 6px 10px;\r\n  border: 1px solid var(--compact-border);\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  color: var(--compact-text);\r\n  background: var(--compact-white);\r\n  cursor: pointer;\r\n  transition: border-color 0.2s ease;\r\n}\r\n\r\n.pagination-select:focus {\r\n  outline: none;\r\n  border-color: var(--compact-primary);\r\n}\r\n\r\n.pagination-nav {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.pagination-btn-compact {\r\n  width: 28px;\r\n  height: 28px;\r\n  padding: 0;\r\n  border: 1px solid var(--compact-border);\r\n  border-radius: 6px;\r\n  background: var(--compact-white);\r\n  color: var(--compact-text);\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.pagination-btn-compact:hover:not(:disabled) {\r\n  background: var(--compact-primary-light);\r\n  border-color: var(--compact-primary);\r\n  color: var(--compact-primary);\r\n}\r\n\r\n.pagination-btn-compact:disabled {\r\n  opacity: 0.4;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.pagination-info-compact {\r\n  font-size: 13px;\r\n  color: var(--compact-text);\r\n  font-weight: 500;\r\n  min-width: 50px;\r\n  text-align: center;\r\n}\r\n\r\n.pagination-total-compact {\r\n  font-size: 12px;\r\n  color: var(--compact-text-light);\r\n  font-weight: 500;\r\n}\r\n\r\n/* Loading and Error States */\r\n.compact-modal-loading,\r\n.compact-modal-error {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 40px;\r\n  text-align: center;\r\n}\r\n\r\n.compact-spinner {\r\n  width: 32px;\r\n  height: 32px;\r\n  border: 3px solid var(--compact-border);\r\n  border-top: 3px solid var(--compact-primary);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.compact-modal-loading p {\r\n  margin: 0;\r\n  font-size: 14px;\r\n  color: var(--compact-text-light);\r\n}\r\n\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.compact-modal-error p {\r\n  color: #dc2626;\r\n  margin-bottom: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\n.compact-modal-error button {\r\n  background: var(--compact-primary);\r\n  color: var(--compact-white);\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Updated Modern Compact Manage Cases Section */\r\n.manage-cases-section {\r\n  padding: 16px 20px;\r\n  overflow-y: auto;\r\n  border-radius: 12px;\r\n  min-height: 0;\r\n  flex: 1;\r\n}\r\n\r\n/* Compact Modern Tab System */\r\n.manage-cases-tabs {\r\n  display: flex;\r\n  gap: 2px;\r\n  margin-bottom: 12px;\r\n  background: #f1f5f9;\r\n  padding: 3px;\r\n  border-radius: 8px;\r\n  border: 1px solid #e2e8f0;\r\n}\r\n\r\n.manage-cases-tab {\r\n  flex: 1;\r\n  padding: 8px 14px;\r\n  background: transparent;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.manage-cases-tab.active {\r\n  background: white;\r\n  color: var(--primary-color);\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.manage-cases-tab:hover:not(.active) {\r\n  color: #475569;\r\n  background: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n/* Compact Sub-tabs */\r\n.manage-cases-subtabs {\r\n  display: flex;\r\n  gap: 6px;\r\n  margin-bottom: 16px;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.manage-cases-subtab {\r\n  padding: 8px 18px;\r\n  background: #f8fafc;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.manage-cases-subtab.active {\r\n  background: var(--primary-color);\r\n  color: white;\r\n  border-color: var(--primary-color);\r\n}\r\n\r\n.manage-cases-subtab:hover:not(.active) {\r\n  border-color: #cbd5e1;\r\n  background: #f1f5f9;\r\n}\r\n\r\n/* Compact Cases List */\r\n.manage-cases-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 0;\r\n}\r\n\r\n/* Compact Case Cards */\r\n.manage-case-card {\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 8px;\r\n  padding: 12px 16px;\r\n  transition: all 0.2s ease;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  min-height: 60px;\r\n}\r\n\r\n.manage-case-card:hover {\r\n  border-color: #3b82f6;\r\n  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.manage-case-card.focused {\r\n  border-color: #3b82f6;\r\n  background: #eff6ff;\r\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Disabled/Assigned state */\r\n.manage-case-card.assigned {\r\n  background: #f8f9fa;\r\n  opacity: 0.65;\r\n  cursor: not-allowed !important;\r\n  \r\n  &:hover {\r\n    border-color: #e2e8f0;\r\n    box-shadow: none;\r\n    transform: none;\r\n  }\r\n  \r\n  .case-checkbox {\r\n    cursor: not-allowed;\r\n    opacity: 0.5;\r\n  }\r\n}\r\n\r\n.manage-case-checkbox {\r\n  position: static;\r\n  flex-shrink: 0;\r\n  margin: 0;\r\n}\r\n\r\n.case-checkbox {\r\n  width: 16px;\r\n  height: 16px;\r\n  cursor: pointer;\r\n  accent-color: var(--primary-color);\r\n}\r\n\r\n.manage-case-details {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 0;\r\n  min-height: auto;\r\n}\r\n\r\n.manage-case-main-info {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.manage-case-parties {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #1e293b;\r\n  margin: 0 0 4px 0;\r\n  line-height: 1.3;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.manage-case-secondary-info {\r\n  display: flex;\r\n  gap: 16px;\r\n  margin: 0;\r\n  align-items: center;\r\n}\r\n\r\n.manage-case-info-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 11px;\r\n  padding: 0;\r\n  background: none;\r\n  border: none;\r\n  border-radius: 0;\r\n}\r\n\r\n.manage-case-label {\r\n  font-weight: 500;\r\n  color: #64748b;\r\n  font-size: 10px;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  min-width: auto;\r\n}\r\n\r\n.manage-case-info-item span:last-child {\r\n  color: #475569;\r\n  font-weight: 500;\r\n  font-size: 11px;\r\n}\r\n\r\n.manage-case-right-info {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  padding: 0;\r\n  border: none;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.manage-case-status {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.manage-case-status-badge {\r\n  padding: 2px 8px;\r\n  border-radius: 12px;\r\n  font-size: 9px;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  border: 1px solid;\r\n  white-space: nowrap;\r\n}\r\n\r\n.manage-case-status-badge.disposed {\r\n  background: #dcfce7;\r\n  color: #166534;\r\n  border-color: #bbf7d0;\r\n}\r\n\r\n.manage-case-status-badge.pending {\r\n  background: #fef3c7;\r\n  color: #92400e;\r\n  border-color: #fde68a;\r\n}\r\n\r\n.manage-case-status-badge.na {\r\n  background: #f1f5f9;\r\n  color: #64748b;\r\n  border-color: #e2e8f0;\r\n}\r\n\r\n.manage-case-date {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: flex-end;\r\n  gap: 2px;\r\n  font-size: 10px;\r\n}\r\n\r\n.manage-case-date .manage-case-label {\r\n  margin: 0;\r\n  font-size: 9px;\r\n}\r\n\r\n.manage-case-date span:last-child {\r\n  color: #1e293b;\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Loading, Error, Empty States */\r\n.manage-cases-loading,\r\n.manage-cases-error,\r\n.manage-cases-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 32px 20px;\r\n  text-align: center;\r\n  background: #f8fafc;\r\n  border-radius: 8px;\r\n  border: 1px dashed #cbd5e1;\r\n}\r\n\r\n.manage-cases-spinner {\r\n  width: 24px;\r\n  height: 24px;\r\n  border: 2px solid #e2e8f0;\r\n  border-top: 2px solid #3b82f6;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.manage-cases-loading p,\r\n.manage-cases-empty p {\r\n  margin: 0;\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  font-weight: 500;\r\n}\r\n\r\n.manage-cases-error p {\r\n  color: #dc2626;\r\n  margin-bottom: 12px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n}\r\n\r\n.manage-cases-error button {\r\n  background: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.manage-cases-error button:hover {\r\n  background: #b91c1c;\r\n}\r\n\r\n.options-courts{\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n\r\n/* Selection Counter Styles */\r\n.selection-counter {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 8px 12px;\r\n  background: #f1f5f9;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 6px;\r\n  margin-bottom: 12px;\r\n  font-size: 12px;\r\n  flex-wrap: wrap; // Allow wrapping on smaller screens\r\n  gap: 8px;\r\n}\r\n\r\n/* Keyboard Navigation Hint */\r\n.keyboard-nav-hint {\r\n  padding: 6px 12px;\r\n  background: #eff6ff;\r\n  border: 1px solid #bfdbfe;\r\n  border-radius: 6px;\r\n  margin-bottom: 12px;\r\n  text-align: center;\r\n  \r\n  small {\r\n    color: #1e40af;\r\n    font-size: 11px;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  kbd {\r\n    display: inline-block;\r\n    padding: 2px 6px;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    line-height: 1;\r\n    color: #1e293b;\r\n    background: white;\r\n    border: 1px solid #cbd5e1;\r\n    border-radius: 3px;\r\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\r\n    margin: 0 2px;\r\n  }\r\n}\r\n\r\n.selection-count {\r\n  font-weight: 600;\r\n  color: #475569;\r\n}\r\n\r\n.selection-actions {\r\n  display: flex;\r\n  gap: 8px; // ensures space between all action items\r\n  align-items: center;\r\n  margin-left: auto; // Push actions to the right\r\n}\r\n\r\n.select-all-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Base styles for new action buttons */\r\n.select-all-cases-btn,\r\n.clear-page-btn {\r\n  padding: 4px 8px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n\r\n  &:disabled {\r\n    opacity: 0.5;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n/* Specific styles for the new buttons */\r\n.select-all-cases-btn {\r\n  background: var(--compact-primary);\r\n  color: white;\r\n\r\n  &:hover:not(:disabled) {\r\n    background: #1d4ed8;\r\n  }\r\n}\r\n\r\n.clear-page-btn {\r\n  background: var(--compact-warning);\r\n  color: white;\r\n\r\n  &:hover:not(:disabled) {\r\n    background: var(--compact-warning-dark);\r\n  }\r\n}\r\n\r\n.clear-selection-btn {\r\n  padding: 4px 8px;\r\n  background: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  font-size: 10px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n}\r\n\r\n.clear-selection-btn:hover {\r\n  background: #b91c1c;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Limit Exceeded Modal Styles */\r\n.limit-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: rgba(15, 23, 42, 0.7);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1001;\r\n  padding: 16px;\r\n}\r\n\r\n.limit-modal-container {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\r\n  width: 100%;\r\n  max-width: 400px;\r\n  overflow: hidden;\r\n  animation: limit-modal-appear 0.3s forwards cubic-bezier(0.34, 1.56, 0.64, 1);\r\n}\r\n\r\n@keyframes limit-modal-appear {\r\n  from {\r\n    transform: translateY(20px) scale(0.95);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.limit-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 20px;\r\n  background: #fef2f2;\r\n  border-bottom: 1px solid #fecaca;\r\n}\r\n\r\n.limit-modal-header h4 {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #dc2626;\r\n  margin: 0;\r\n}\r\n\r\n.limit-modal-close {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  color: #dc2626;\r\n  cursor: pointer;\r\n  padding: 4px;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.limit-modal-close:hover {\r\n  background: rgba(220, 38, 38, 0.1);\r\n}\r\n\r\n.limit-modal-content {\r\n  padding: 20px;\r\n  text-align: center;\r\n}\r\n\r\n.limit-modal-content p {\r\n  margin: 0 0 12px 0;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n}\r\n\r\n.limit-modal-content p:last-child {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.limit-modal-content strong {\r\n  color: #dc2626;\r\n  font-weight: 600;\r\n}\r\n\r\n.limit-modal-footer {\r\n  padding: 16px 20px;\r\n  background: #f8fafc;\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 12px;\r\n}\r\n\r\n.limit-modal-upgrade-btn {\r\n  padding: 8px 24px;\r\n  background: #ff7e5f;\r\n  background: linear-gradient(to right, #ff7e5f, #feb47b);\r\n  color: #fff;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n\r\n.limit-modal-btn {\r\n  padding: 8px 24px;\r\n  background: #dc2626;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.limit-modal-btn:hover {\r\n  background: #b91c1c;\r\n  transform: translateY(-1px);\r\n}\r\n\r\n.sa-search-wrapper {\r\n  display: flex;\r\n  align-items: center;\r\n  position: relative;\r\n}\r\n\r\n.sa-search-input-container {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.sa-search-input {\r\n  padding: 8px 12px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px;\r\n  font-size: 14px;\r\n  outline: none;\r\n  background: white;\r\n}\r\n\r\n.sa-search-loading {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  color: var(--primary-color);\r\n}\r\n\r\n.sa-spinner {\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n.icon-btn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border: none;\r\n  border-radius: var(--radius-sm);\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  background: var(--border-light);\r\n  color: var(--text-medium);\r\n  position: relative;\r\n\r\n  svg {\r\n    width: 16px;\r\n    height: 16px;\r\n  }\r\n\r\n  &.active {\r\n    background: var(--primary-light);\r\n    color: var(--primary-color);\r\n    border: 1px solid var(--primary-color);\r\n  }\r\n\r\n  &.active-filter {\r\n    background: var(--primary-light-bg);\r\n  }\r\n\r\n  .filter-indicator {\r\n    position: absolute;\r\n    top: -2px;\r\n    right: -2px;\r\n    width: 8px;\r\n    height: 8px;\r\n    background-color: var(--primary-color);\r\n    border-radius: 50%;\r\n    border: 2px solid white;\r\n  }\r\n}\r\n\r\n/* Responsive Adjustments */\r\n@media (max-width: 1200px) {\r\n  .compact-modal-container {\r\n    max-width: 900px;\r\n  }\r\n\r\n  .image-style-stats-container {\r\n    flex-wrap: wrap;\r\n  }\r\n\r\n  .image-style-stat-card {\r\n    min-width: 160px;\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  .manage-cases-section {\r\n    padding: 16px;\r\n  }\r\n  \r\n  .manage-cases-tabs {\r\n    flex-direction: column;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .manage-cases-tab {\r\n    padding: 8px 12px;\r\n  }\r\n\r\n  .manage-case-details {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .manage-case-secondary-info {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .manage-case-right-info {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n  }\r\n\r\n  .image-style-stats-container {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .image-style-stat-card {\r\n    min-width: auto;\r\n  }\r\n\r\n  .compact-modal-content {\r\n    max-height: 1000px;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .selection-counter {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .selection-actions {\r\n    width: 100%;\r\n    justify-content: flex-start;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .manage-case-card {\r\n    padding: 10px 12px;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n  }\r\n  \r\n  .manage-case-checkbox {\r\n    position: absolute;\r\n    top: 12px;\r\n    right: 12px;\r\n  }\r\n  \r\n  .manage-case-details {\r\n    width: 100%;\r\n    padding-right: 30px;\r\n  }\r\n  \r\n  .manage-case-parties {\r\n    white-space: normal;\r\n    overflow: visible;\r\n    text-overflow: initial;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2;\r\n    -webkit-box-orient: vertical;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .selection-counter {\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    align-items: stretch;\r\n    text-align: center;\r\n  }\r\n  \r\n  .clear-selection-btn {\r\n    width: 100%;\r\n    padding: 6px 12px;\r\n  }\r\n  \r\n  .limit-modal-container {\r\n    max-width: 350px;\r\n    margin: 0 16px;\r\n  }\r\n\r\n  .compact-modal-footer {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .manage-cases-pagination-compact {\r\n    width: 100%;\r\n  }\r\n\r\n  .footer-buttons {\r\n    width: 100%;\r\n    justify-content: stretch;\r\n  }\r\n\r\n  .footer-buttons button {\r\n    flex: 1;\r\n  }\r\n\r\n  .image-style-stat-card {\r\n    padding: 16px 12px;\r\n    gap: 10px;\r\n  }\r\n\r\n  .image-style-stat-card .stat-icon {\r\n    width: 40px;\r\n    height: 40px;\r\n  }\r\n\r\n  .image-style-stat-card .stat-value {\r\n    font-size: 28px;\r\n  }\r\n}\r\n\r\n@media (max-width: 500px) {\r\n  .manage-cases-section {\r\n    padding: 16px;\r\n  }\r\n\r\n  .manage-cases-tabs {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .manage-cases-tab {\r\n    text-align: center;\r\n  }\r\n\r\n  .manage-case-card {\r\n    padding: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
